/** UI-only display helpers — do not use for API payloads. */

export const formatClubType = (value) => {
  if (!value) return "-";
  if (value === "individual") return "Club";
  if (value === "Organisation" || value === "Organization") return "Club";
  return value;
};
